import { render } from "./refer.vue?vue&type=template&id=22d22c26&scoped=true"
import script from "./refer.vue?vue&type=script&lang=js"
export * from "./refer.vue?vue&type=script&lang=js"

import "./refer.vue?vue&type=style&index=0&id=22d22c26&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tap-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d22c26"]])

export default __exports__